var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drink-card-container" },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchForm, size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "请输入卡名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "keywords", $$v)
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.isEnable,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "isEnable", $$v)
                        },
                        expression: "searchForm.isEnable",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "启用", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" }, attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "小标题",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "title2",
                  label: "大标题",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "卡片图", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.imgUrl
                          ? _c("el-image", {
                              staticStyle: {
                                width: "48px",
                                height: "48px",
                                "border-radius": "4px",
                              },
                              attrs: {
                                src: _vm.resPath + row.imgUrl,
                                "preview-src-list": [_vm.resPath + row.imgUrl],
                                fit: "cover",
                              },
                            })
                          : _c("span", { staticStyle: { color: "#ccc" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "售价/原价", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#F56C6C",
                              "font-weight": "600",
                            },
                          },
                          [_vm._v("¥" + _vm._s(row.buyPrice))]
                        ),
                        _vm._v(" "),
                        row.originalPrice
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#ccc",
                                  "font-size": "11px",
                                  "text-decoration": "line-through",
                                  "margin-left": "4px",
                                },
                              },
                              [_vm._v("¥" + _vm._s(row.originalPrice))]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "promptMsg",
                  label: "提示语",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "75", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.isEnable === 1 ? "success" : "danger",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.isEnable === 1 ? "启用" : "禁用") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "itemCount",
                  label: "品项数",
                  width: "70",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "155", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.createDate
                              ? _vm.parseTime(
                                  row.createDate,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "200",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleToggleStatus(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.isEnable === 1 ? "禁用" : "启用") +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#F56C6C" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑畅饮卡" : "新增畅饮卡",
            visible: _vm.editVisible,
            direction: "rtl",
            size: "60%",
            "wrapper-closable": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawer-body" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "edit-tabs",
                  attrs: { type: "border-card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "基本信息", name: "basic" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "editFormRef",
                          attrs: {
                            model: _vm.editForm,
                            "label-width": "auto",
                            size: "small",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "小标题",
                                        prop: "title",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入小标题",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "如：98元畅饮卡",
                                          maxlength: "100",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.editForm.title,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editForm, "title", $$v)
                                          },
                                          expression: "editForm.title",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "大标题" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder:
                                            "如：98元即认证会员礼券包",
                                          maxlength: "100",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.editForm.title2,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "title2",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.title2",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "原价（元）" } },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          precision: 2,
                                          min: 0,
                                          max: 99999,
                                        },
                                        model: {
                                          value: _vm.editForm.originalPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "originalPrice",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.originalPrice",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "现价（元）",
                                        prop: "buyPrice",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入现价",
                                            trigger: "blur",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          precision: 2,
                                          min: 0.01,
                                          max: 99999,
                                        },
                                        model: {
                                          value: _vm.editForm.buyPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "buyPrice",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.buyPrice",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "提示语" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  placeholder:
                                    "如：含1张免费饮品券和3张买一赠一券",
                                  maxlength: "500",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.editForm.promptMsg,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editForm, "promptMsg", $$v)
                                  },
                                  expression: "editForm.promptMsg",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "购买及使用规则" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "请输入购买及使用规则",
                                },
                                model: {
                                  value: _vm.editForm.rule,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editForm, "rule", $$v)
                                  },
                                  expression: "editForm.rule",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否启用" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.editForm.isEnable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editForm,
                                                "isEnable",
                                                $$v
                                              )
                                            },
                                            expression: "editForm.isEnable",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "排序" } },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: { min: 0, max: 9999 },
                                        model: {
                                          value: _vm.editForm.sort,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editForm, "sort", $$v)
                                          },
                                          expression: "editForm.sort",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "购物车展示" } },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-value": 1,
                                          "inactive-value": 0,
                                          "active-text": "展示",
                                          "inactive-text": "不展示",
                                        },
                                        model: {
                                          value: _vm.editForm.showInCart,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "showInCart",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.showInCart",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "支付页展示" } },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-value": 1,
                                          "inactive-value": 0,
                                          "active-text": "展示",
                                          "inactive-text": "不展示",
                                        },
                                        model: {
                                          value: _vm.editForm.showInPayment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editForm,
                                              "showInPayment",
                                              $$v
                                            )
                                          },
                                          expression: "editForm.showInPayment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "封面图 / 背景图 / 榜单图" } },
                            [
                              _c(
                                "div",
                                { staticClass: "img-upload-row" },
                                _vm._l(_vm.imgFields, function (field) {
                                  return _c(
                                    "div",
                                    {
                                      key: field.key,
                                      staticClass: "img-upload-item",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "img-upload-label" },
                                        [_vm._v(_vm._s(field.label))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "loading",
                                              rawName: "v-loading",
                                              value:
                                                _vm.uploadingMap[field.key],
                                              expression:
                                                "uploadingMap[field.key]",
                                            },
                                          ],
                                          staticClass: "img-upload-box",
                                        },
                                        [
                                          _vm.editForm[field.key]
                                            ? [
                                                _c("el-image", {
                                                  staticClass: "img-preview",
                                                  attrs: {
                                                    src:
                                                      _vm.resPath +
                                                      _vm.editForm[field.key],
                                                    "preview-src-list": [
                                                      _vm.resPath +
                                                        _vm.editForm[field.key],
                                                    ],
                                                    fit: "cover",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "img-clear",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        _vm.editForm[
                                                          field.key
                                                        ] = ""
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-close",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "img-upload-btn",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.triggerUpload(
                                                          field.key
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-upload2",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "img-placeholder",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.triggerUpload(
                                                        field.key
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                  }),
                                                ]
                                              ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        ref: "upload_" + field.key,
                                        refInFor: true,
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          type: "file",
                                          accept:
                                            "image/jpeg,image/png,image/gif,image/webp",
                                        },
                                        on: {
                                          change: function (e) {
                                            return _vm.handleUpload(
                                              e,
                                              field.key
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "优惠券组合", name: "items" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "12px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus",
                              },
                              on: { click: _vm.addItem },
                            },
                            [_vm._v("添加券包")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", icon: "el-icon-time" },
                              on: { click: _vm.openChangeLogs },
                            },
                            [_vm._v("变更记录")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "共 " +
                                  _vm._s(_vm.editForm.items.length) +
                                  " 项"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.editForm.items, function (item, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticStyle: {
                              border: "1px solid #e4e7ed",
                              "border-radius": "6px",
                              padding: "14px",
                              "margin-bottom": "14px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "12px",
                                  "margin-bottom": "12px",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "320px" },
                                    attrs: {
                                      filterable: "",
                                      placeholder:
                                        "请选择券包（仅显示有效券包）",
                                      size: "small",
                                    },
                                    on: {
                                      change: function (val) {
                                        return _vm.onPackageSelect(item, val)
                                      },
                                    },
                                    model: {
                                      value: item.packageId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "packageId", $$v)
                                      },
                                      expression: "item.packageId",
                                    },
                                  },
                                  _vm._l(_vm.couponPackages, function (pkg) {
                                    return _c("el-option", {
                                      key: pkg.id,
                                      attrs: {
                                        label:
                                          (pkg.packageAlias ||
                                            pkg.packageName) +
                                          "（" +
                                          pkg.packageCode +
                                          "）",
                                        value: pkg.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#606266",
                                      "font-size": "13px",
                                    },
                                  },
                                  [_vm._v("排序")]
                                ),
                                _vm._v(" "),
                                _c("el-input-number", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    min: 0,
                                    max: 999,
                                    size: "small",
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: item.sort,
                                    callback: function ($$v) {
                                      _vm.$set(item, "sort", $$v)
                                    },
                                    expression: "item.sort",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      color: "#F56C6C",
                                      "margin-left": "auto",
                                    },
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editForm.items.splice(idx, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            item._pkg
                              ? [
                                  _c(
                                    "el-descriptions",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                      attrs: {
                                        column: 3,
                                        size: "small",
                                        border: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "券包名称" } },
                                        [_vm._v(_vm._s(item._pkg.packageName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "展示别名" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              placeholder:
                                                item._pkg.packageAlias ||
                                                "请输入展示别名",
                                              size: "small",
                                              maxlength: "50",
                                            },
                                            model: {
                                              value: item.names,
                                              callback: function ($$v) {
                                                _vm.$set(item, "names", $$v)
                                              },
                                              expression: "item.names",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "原价" } },
                                        [
                                          _vm._v(
                                            "¥" + _vm._s(item._pkg.oldPrice)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "售价" } },
                                        [_vm._v("¥" + _vm._s(item._pkg.price))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "成本类型" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item._pkg.rateType === 1
                                                ? "按比例(%)"
                                                : "按金额(单价×张数)"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "售价方式" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item._pkg.priceType === 1
                                                ? "按售价"
                                                : "按实际购买金额"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "展示图片" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "loading",
                                                  rawName: "v-loading",
                                                  value: item._uploading,
                                                  expression: "item._uploading",
                                                },
                                              ],
                                              staticClass: "item-img-box",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.triggerItemUpload(
                                                    idx
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              item.iconUrl
                                                ? [
                                                    _c("el-image", {
                                                      staticClass:
                                                        "item-img-preview",
                                                      attrs: {
                                                        src:
                                                          _vm.resPath +
                                                          item.iconUrl,
                                                        fit: "cover",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "item-img-clear",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.$set(
                                                              item,
                                                              "iconUrl",
                                                              ""
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-close",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                : _c("i", {
                                                    staticClass:
                                                      "el-icon-plus item-img-plus",
                                                  }),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            ref: "upload_item_" + idx,
                                            refInFor: true,
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              type: "file",
                                              accept:
                                                "image/jpeg,image/png,image/gif,image/webp",
                                            },
                                            on: {
                                              change: function (e) {
                                                return _vm.handleItemUpload(
                                                  e,
                                                  item
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-descriptions-item",
                                        { attrs: { label: "描述", span: 2 } },
                                        [
                                          _vm._v(
                                            _vm._s(item._pkg.packageDesc || "-")
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "13px",
                                        color: "#303133",
                                        "font-weight": "600",
                                        "margin-bottom": "6px",
                                      },
                                    },
                                    [_vm._v("券明细")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: item._pkg.items,
                                        border: "",
                                        size: "small",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "crmCouponId",
                                          label: "CRM券ID",
                                          width: "100",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "券别名",
                                          "min-width": "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var row = ref.row
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      size: "small",
                                                      maxlength: "50",
                                                      placeholder: "券别名",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.saveCouponAlias(
                                                          row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: row.couponAlias,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "couponAlias",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.couponAlias",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "sendNum",
                                          label: "发券数量",
                                          width: "90",
                                          align: "center",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "原价/张",
                                          width: "90",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var row = ref.row
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.oldPrice != null
                                                        ? row.oldPrice + " 元"
                                                        : "-"
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "券单价",
                                          width: "130",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var row = ref.row
                                                return [
                                                  row.rateNum == null
                                                    ? _c("span", [_vm._v("-")])
                                                    : item._pkg.rateType === 2
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              row.rateNum
                                                            ) +
                                                            " 元\n                    "
                                                        ),
                                                        row.sendNum
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "11px",
                                                                  color:
                                                                    "#909399",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      小计 " +
                                                                    _vm._s(
                                                                      (
                                                                        Number(
                                                                          row.rateNum
                                                                        ) *
                                                                        Number(
                                                                          row.sendNum
                                                                        )
                                                                      ).toFixed(
                                                                        2
                                                                      )
                                                                    ) +
                                                                    " 元\n                    "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(row.rateNum) +
                                                            " %"
                                                        ),
                                                      ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "有效期",
                                          "min-width": "200",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var row = ref.row
                                                return [
                                                  _vm.formatYxq(row)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            "line-height":
                                                              "1.5",
                                                            color: "#606266",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.formatYxq(
                                                                  row
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          ["0", "2"].includes(
                                                            String(
                                                              row.expiryType
                                                            )
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "4px",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-tag",
                                                                    {
                                                                      attrs: {
                                                                        type: _vm.isCouponValid(
                                                                          row
                                                                        )
                                                                          ? "success"
                                                                          : "danger",
                                                                        size: "mini",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            _vm.isCouponValid(
                                                                              row
                                                                            )
                                                                              ? "有效"
                                                                              : "已过期"
                                                                          ) +
                                                                          "\n                      "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "#ccc",
                                                          },
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "券封面",
                                          width: "80",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var row = ref.row
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "loading",
                                                          rawName: "v-loading",
                                                          value: row._uploading,
                                                          expression:
                                                            "row._uploading",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "item-img-box",
                                                      staticStyle: {
                                                        width: "40px",
                                                        height: "40px",
                                                        margin: "0 auto",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.triggerCouponUpload(
                                                            row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      row.couponImgUrl
                                                        ? [
                                                            _c("el-image", {
                                                              staticClass:
                                                                "item-img-preview",
                                                              attrs: {
                                                                src:
                                                                  _vm.resPath +
                                                                  row.couponImgUrl,
                                                                fit: "cover",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "item-img-clear",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.clearCouponImg(
                                                                        row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-close",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        : _c("i", {
                                                            staticClass:
                                                              "el-icon-plus item-img-plus",
                                                          }),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    ref:
                                                      "upload_coupon_" + row.id,
                                                    refInFor: true,
                                                    staticStyle: {
                                                      display: "none",
                                                    },
                                                    attrs: {
                                                      type: "file",
                                                      accept:
                                                        "image/jpeg,image/png,image/gif,image/webp",
                                                    },
                                                    on: {
                                                      change: function (e) {
                                                        return _vm.handleCouponUpload(
                                                          e,
                                                          row
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : item.packageId
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#909399",
                                      "font-size": "13px",
                                      padding: "8px 0",
                                    },
                                  },
                                  [_vm._v("加载中...")]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      !_vm.editForm.items.length
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "30px 0",
                                color: "#ccc",
                              },
                            },
                            [
                              _vm._v(
                                "\n          暂无券包，点击「添加券包」开始配置\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "商品展示", name: "goods" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "12px",
                            "margin-bottom": "10px",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "搜索分组名称",
                              clearable: "",
                              size: "small",
                              "prefix-icon": "el-icon-search",
                            },
                            model: {
                              value: _vm.dishGroupKeyword,
                              callback: function ($$v) {
                                _vm.dishGroupKeyword = $$v
                              },
                              expression: "dishGroupKeyword",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "13px",
                              },
                            },
                            [
                              _vm._v("\n            已选 "),
                              _c("b", { staticStyle: { color: "#409EFF" } }, [
                                _vm._v(
                                  _vm._s(_vm.editForm.dishGroupIds.length)
                                ),
                              ]),
                              _vm._v(" 个分组\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.editForm.dishGroupIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.editForm, "dishGroupIds", $$v)
                            },
                            expression: "editForm.dishGroupIds",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.dishGroupsLoading,
                                  expression: "dishGroupsLoading",
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.filteredDishGroups,
                                border: "",
                                size: "small",
                                "row-class-name": function (ref) {
                                  var row = ref.row

                                  return _vm.editForm.dishGroupIds.includes(
                                    row.id
                                  )
                                    ? "row-selected"
                                    : ""
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { width: "50", align: "center" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c(
                                          "el-checkbox",
                                          { attrs: { label: row.id } },
                                          [_vm._v(" ")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "id",
                                  label: "ID",
                                  width: "70",
                                  align: "center",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "name",
                                  label: "分组名称（中）",
                                  "min-width": "140",
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "nameEn",
                                  label: "分组名称（英）",
                                  "min-width": "120",
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "图标",
                                  width: "70",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        row.iconUrl
                                          ? _c("el-image", {
                                              staticStyle: {
                                                width: "36px",
                                                height: "36px",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: row.iconUrl,
                                                fit: "cover",
                                              },
                                            })
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: { color: "#ccc" },
                                              },
                                              [_vm._v("-")]
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goodsCount",
                                  label: "关联商品",
                                  width: "80",
                                  align: "center",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "隐藏",
                                  width: "60",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                row.hideFlag === 1
                                                  ? "warning"
                                                  : "success",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  row.hideFlag === 1
                                                    ? "是"
                                                    : "否"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.filteredDishGroups.length
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "30px 0",
                                color: "#ccc",
                              },
                            },
                            [_vm._v("\n          暂无菜品分组数据\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.editVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        loading: _vm.saving,
                      },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "券包变更记录",
            visible: _vm.changeLogVisible,
            width: "860px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeLogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.changeLogLoading,
                  expression: "changeLogLoading",
                },
              ],
              attrs: { data: _vm.changeLogs, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "操作类型", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.action === 1
                                  ? "success"
                                  : row.action === 3
                                  ? "danger"
                                  : "warning",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.action === 1
                                    ? "新增"
                                    : row.action === 3
                                    ? "删除"
                                    : "修改"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "原券包",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.oldPackageName || "-"))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#909399",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(_vm._s(row.oldPackageCode || ""))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "新券包",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.newPackageName || "-"))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#909399",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(_vm._s(row.newPackageCode || ""))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "变更时间", width: "155", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.createTime
                              ? _vm.parseTime(
                                  row.createTime,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.changeLogLoading && _vm.changeLogs.length === 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    color: "#909399",
                    padding: "20px",
                  },
                },
                [_vm._v("暂无变更记录")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }